import { FunctionComponent } from 'react';
import { Optional } from '../../../../Utils/Types';

export const TwitchAuthButton: FunctionComponent = () => {
  function authenticate(): void {
    const clientId: Optional<string> = process.env.REACT_APP_TWITCH_CLIENT_ID;
    const redirectUri: Optional<string> = process.env.REACT_APP_TWITCH_REDIRECT_URI;
    if (clientId !== undefined) {
      const url: string = `https://id.twitch.tv/oauth2/authorize?client_id=${clientId}&response_type=token&redirect_uri=${redirectUri}`;
      window.location.href = url;
    }
  }

  return (
    <button
      className="items-center px-4 py-1 space-x-2 text-white border border-black rounded-lg h-stack bg-twitch border-opacity-20 hover:bg-opacity-60 active:bg-opacity-40"
      onClick={authenticate}
    >
      <img className="w-5 h-5" src="/images/icons/twitch_icon_white.svg" />
      <div>Authenticate</div>
    </button>
  );
};
